export default __webpack_public_path__ + "static/industry_experts_join_mural-625d24bf0643e565fd4d2790a4ecf7c3.svg";